import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const fetchWalletBalance = createAsyncThunk(
  "wallet/fetchBalance",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/wallet");
      return response.data.data;
    } catch (error) {
      console.error("Fetch wallet balance error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to fetch wallet balance",
        );
      }
      return rejectWithValue("Failed to fetch wallet balance");
    }
  },
);

export const fetchTransactionHistory = createAsyncThunk(
  "wallet/fetchTransactions",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, limit = 10 } = params;
      const response = await axios.get(`/payments?page=${page}&limit=${limit}`);
      return {
        transactions: response.data.data,
        pagination: response.data.pagination,
      };
    } catch (error) {
      console.error("Fetch transaction history error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to fetch transaction history",
        );
      }
      return rejectWithValue("Failed to fetch transaction history");
    }
  },
);
